export default __webpack_public_path__ + "static/media/description-icon.0a4e3bb2.svg";